import { createContext } from 'react'

export const UserContext = createContext({
  userName: null,
  userEmail: null,
  userRole: null,
})
